import { Route } from '@/app/router'

const Supplier = () => import('./index.vue')

export default new Route('/suppliers/:id', Supplier)
	.as('Dashboard:Supplier')
	.permissions(['VIEW_OEM_SUPPLIER', 'OEM_ENABLED'])
